import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

/**
 * A blog page whose server could not reach the API renders nothing and asks again from the
 * browser, where the request is the visitor's, the way a trainer's page does.
 */
export const useLoadInBrowser = (loaded: unknown) => {
  const router = useRouter();
  useEffect(() => {
    if (!loaded) void router.invalidate();
  }, [loaded, router]);
};
